import React, {useRef, useState} from "react"
import * as Yup from "yup"
import {useSelector} from "react-redux"
import {useForm} from "react-hook-form"
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from "reactstrap"
import Switch from "react-bootstrap-switch";

// components
import DynamicModuleLang from "./_langs";
import {GenericButton} from "../../../components/buttons/customButtons";
import {GenericTableButton} from "../../../components/buttons/buttonsActions";
import Separator from "../../../components/Separator";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";
import TranslateButton from "../../../components/buttons/TranslateButton";
import CustomFormTitle from "../../../components/genericComponents/CustomFormTitle"

// labels
import {PH_CODE, PH_IMAGE, PH_NAME, PH_ORDER} from "../../../components/i18n/placeHolders"
import {LB_CODE, INTERNATIONAL, LB_NAME, LB_ORDER, LB_STATUS, REQUIRED, LB_IMG} from "../../../components/i18n/i18n"
import {TT_CLOSE, TT_HISTORY, TT_SAVE} from "../../../components/i18n/toolTips";

// services
import {udnService} from "../../../jwt/_services/configuration/udnService"

// utils
import {getStateByPath} from "../../../redux/selectors";

// actions
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import DynamicModuleCategories from "./category/Categories";




const DynamicModuleForm = props => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const { udn, app, editMode, domainObject} = componentState?.data;

    const {fbDataBase} = app
    const translatableLangs = domainObject?.translatedLangs || []

    const [status, setStatus] = useState(domainObject?.status || true);
    const [langs, setlangs] = useState(domainObject?.langs || []);
    const [showModal, setShowModal] = useState(true)

    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
        name: Yup.string().required( REQUIRED ),
        code: Yup.string().required( REQUIRED ),
    });


    const { register, handleSubmit, reset, errors } = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            name: domainObject?.name,
            code: domainObject?.code,
            showOrder: domainObject?.showOrder,
            image: domainObject?.image,
        }
    });


    const onSubmit = (data, event) => {
        const dataFormValue = event.target.getAttribute('data-form');

        // Verifica si el evento proviene del formulario interno
        if (dataFormValue === 'activity' || dataFormValue === 'category') {
            console.log("Evento ignorado porque se ejecuto en el formulario interno");
            return;
        }


        let dataRequest = {
            fbDataBase,
            item : {
                ...data,
                langs
            }
        };

        if(status !== undefined && status !== null)
            dataRequest.item.status = status;

        if (!editMode)
            genericIndexedActions.save(path, udnService, dataRequest)
        else {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericIndexedActions.update(path, udnService, id, dataRequest)
        }

        closeForm()
    };

    const closeForm = () => {
        reset();
        props.onClose()
    }


    return <Form onSubmit={ handleSubmit(onSubmit) }>
        <Card className={!!domainObject ? 'card-modal-big': 'card-modal'}>
            <CardTitle className="bg-light border-bottom p-2 mb-0">
                <CustomFormTitle domainObject={domainObject} />

                <div className={'top-right'}>
                    <GenericButton
                        style={'table'}
                        icon={'fa-save'}
                        toolTip={TT_SAVE}
                        permission={'add'}
                        type={'submit'}
                    />
                    {
                        editMode && <>
                            <GenericTableButton
                                toolTip={TT_HISTORY}
                                icon={'fa-clock'}
                                permission={'search'}
                                onClick={showHistory}
                            />
                            <TranslateButton item={domainObject} service={udnService} />
                        </>
                    }
                    <Separator/>
                    <GenericButton
                        style={'danger-secondary'}
                        toolTip={TT_CLOSE}
                        icon={'fa-times'}
                        permission={'search'}
                        onClick={closeForm}
                    />
                </div>
            </CardTitle>
            <CardBody className={'card-body-modal'}>
                <Row>
                    <Col>
                        <Row>
                            <Col sm={3}>
                                <FormGroup>
                                    <Label>{LB_CODE}</Label>
                                    <Input
                                        type="text"
                                        name="code"
                                        placeholder={PH_CODE}
                                        innerRef={register}
                                    />
                                    {errors.code && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.code?.message}</div>}
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup>
                                    <Label>{LB_NAME}</Label>
                                    <Input
                                        type="text"
                                        name="name"
                                        placeholder={PH_NAME}
                                        innerRef={register}
                                    />
                                    { errors.name && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.name?.message}</div>}
                                </FormGroup>
                            </Col>
                            <Col md="2">
                                <FormGroup>
                                    <Label>{LB_STATUS}</Label>
                                    <br/>
                                    <Switch
                                        animate={true}
                                        offText={"No"}
                                        onText={"Si"}
                                        value={status}
                                        onChange={ () => setStatus(!status) }
                                    />
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label>{LB_ORDER}</Label>
                                    <Input
                                        type="number"
                                        name="showOrder"
                                        placeholder={PH_ORDER}
                                        innerRef={register}
                                    />
                                    { errors.showOrder && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.showOrder?.message}</div>}
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup>
                                    <Label>{LB_IMG}</Label>
                                    <Input
                                        type="text"
                                        name="image"
                                        placeholder={PH_IMAGE}
                                        innerRef={register}
                                    />
                                    { errors.image && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.image?.message}</div>}
                                </FormGroup>
                            </Col>
                        </Row>
                        <CardTitle className="bg-light border-bottom p-3 mb-0">
                            <i className="fas fa-language mr-2"/>
                            { INTERNATIONAL }
                        </CardTitle>
                        <CardBody>
                            <DynamicModuleLang
                                langs={langs}
                                setLangs={setlangs}
                                translatableLangs={translatableLangs}
                            />
                        </CardBody>
                    </Col>



                    {
                        !!domainObject && <Col>
                            <DynamicModuleCategories mainPath={ path }/>
                        </Col>
                    }

                </Row>
            </CardBody>
            {
                showModal && <LogHistoryModal
                    ref={ modalRef }
                    item={ domainObject }
                />
            }
        </Card>
    </Form>
}
export default DynamicModuleForm